<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
  <g>
    <path d="M237.82,150A87.82,87.82,0,1,1,150,62.18,87.82,87.82,0,0,1,237.82,150"/>
    <polygon points="126.05 253.36 173.95 253.36 150 300 126.05 253.36"/>
    <polygon points="173.95 46.64 126.05 46.64 150 0 173.95 46.64"/>
    <polygon points="59.66 206.3 93.7 240.34 44.12 255.88 59.66 206.3"/>
    <polygon points="240.34 93.7 206.3 59.66 255.88 44.12 240.34 93.7"/>
    <polygon points="46.64 126.05 46.64 173.95 0 150 46.64 126.05"/>
    <polygon points="253.36 173.95 253.36 126.05 300 150 253.36 173.95"/>
    <polygon points="93.7 59.66 59.66 93.7 44.12 44.12 93.7 59.66"/>
    <polygon points="206.3 240.34 240.34 206.3 255.88 255.88 206.3 240.34"/>
  </g>
</svg>
